<nf-table-layout
  #table
  class="filter-grid-table-layout"
  [hideTitle]="true"
  [hideClearAll]="true"
  [hideSearch]="true"
  [autoResizeGrid]="false"
  [gridOptions]="gridOptions"
  [data]="data"
>
</nf-table-layout>
